import React from 'react';
import { FIELD_R, FOLLICLE_SLOTS, follicleRadius, REST_RADIUS } from '../utils/follicleField';
type MiniFollicleClusterProps = {
  n: number;
  label: string;
};
const STROMA = '#f3dbe0';
const STROMA_EDGE = '#dcb7c0';
const GRANULOSA = '#e7bfca';
const STAIN = '#7b4c84';
const OUTER = FIELD_R + 6;

/** Static, minimal histology-style follicle cluster for explanatory use. */
export function MiniFollicleCluster({
  n,
  label
}: MiniFollicleClusterProps) {
  return <svg viewBox={`${-OUTER - 4} ${-OUTER - 4} ${(OUTER + 4) * 2} ${(OUTER + 4) * 2}`} className="block h-28 w-28 md:h-32 md:w-32" role="img" aria-label={label} data-id="element-175" data-mp="3csmvdb80bak1">
      <circle r={OUTER} fill={STROMA} stroke={STROMA_EDGE} strokeWidth={1.5} data-id="element-176" data-mp="2yv80hqyziako" />
      {FOLLICLE_SLOTS.map((s, i) => {
      const r = follicleRadius(i, n);
      const grown = r > REST_RADIUS + 2;
      return <g key={i} transform={`translate(${s.x.toFixed(1)} ${s.y.toFixed(1)})`} data-id="element-177" data-mp="120bkhyc1il2r" data-mpi={i}>
            <circle r={r} fill={grown ? GRANULOSA : STROMA} stroke={STAIN} strokeOpacity={grown ? 0.75 : 0.5} strokeWidth={grown ? 1.4 : 1} data-id="element-178" data-mp="1mr8129plqphz" />
            {r > 7 && <>
                <circle r={r * 0.64} fill="#ffffff" fillOpacity={0.92} data-id="element-179" data-mp="1injplfxun9rg" />
                <circle cx={r * 0.3} cy={-r * 0.2} r={Math.max(1.8, r * 0.15)} fill={STAIN} fillOpacity={0.85} data-id="element-180" data-mp="1wgj7tpp0ni2p" />
              </>}
          </g>;
    })}
    </svg>;
}